import "./assets/scss/main.scss";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import axios from "./plugins/axios";
import * as PhilaUI from "@phila/phila-ui";
import mgtVue from "./plugins/mgt-vue";
import notifications from "./plugins/notifications";
import "es6-promise/auto";
import "babel-polyfill";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
} from "vee-validate/dist/vee-validate.full.esm";

extend("mintime", {
  params: ["target"],
  validate(value, { target }) {
    var a = parseInt(value.replaceAll(":", "") || 0);
    var b = parseInt(target.replaceAll(":", "") || 0);

    return a > b;
  },
  message: "The Time End field must be greater than Time Start field.",
});

extend("time", {
  validate(value) {
    var c = value.split(":");
    var h = parseInt(c[0]);
    var m = parseInt(c[1]);

    return h < 24 && m < 60;
  },
  message: "The field must be numeric as 24-hour clock, example 1330",
});

Vue.config.productionTip = false;
//register it
Vue.use(PhilaUI, {});
//Vue.use(mgtVue, { store });
Vue.use(notifications, { store });
Vue.use(axios, { store });
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
